import { __awaiter } from '../../external_node_modules/tslib/tslib.es6.js';
import { addEvent } from '../../analytics/index.js';
import { webThreeDSStatus } from '../../api/platform/web/web3DSStatus.js';
import '../../api/baseRequest.js';
import { PLATFORMS } from '../../constants/platforms.js';
import settings from '../../settings.js';
import { webCommitPurchase } from '../../api/platform/web/webCommitPurchase.js';
import { DWH_EVENTS } from '../../constants/dwhEvents.js';
import { EVENTS } from '../../constants/events.js';
import { PURCHASE_ERROR_CODES } from '../../constants/purchaseErrorCodes.js';
import { PURCHASE_STATUSES } from '../../constants/purchaseStatuses.js';
import { COMMIT_NEXT_ACTION_CODES } from '../../constants/web/nextActionCodes.js';
import { THREE_DS_STATUSES } from '../../constants/web/threeDSStatuses.js';
import { TSV_ACCOUNT_STATUSES } from '../../constants/web/tsvAccountStatuses.js';
import '../../constants/web/tsvMethods.js';
import '../../constants/web/tsvMethodsErrorCodes.js';
import events from '../../core/event/index.js';
import { checkout as checkout$2 } from '../../core/platform/EpicGamesStore/checkout.js';
import { checkout as checkout$1 } from '../../core/platform/Steam/checkout.js';
import { checkout } from '../../core/platform/WinStore/checkout.js';
import { setBlur } from '../isBlur.js';
import { setLoading } from '../isLoading.js';
import { setPurchaseResult } from '../purchaseResult.js';
import { toogleVisibilityConfirmPurchasePopup, setThreeDSValidation, setThreeDSRedirectUrl, setValidationErrorCode, setTwoFactorValidation } from '../purchaseTwoFactor.js';
import { collectBrowserInfo } from '../../utils/collectBrowserInfo.js';
import detectPlatform from '../../utils/detectPlatform.js';
import getPurchaseErrorCodeText from '../../utils/errorsText.js';
import { warn } from '../../utils/logger.js';
import { openUrl } from '../../utils/openUrl.js';

function sendDwhEvent(product, event) {
    addEvent(event, { bundle_id: product.externalProductId, product_code: product.code });
}
function showPurchaseResult(product, isSuccess, errorCode) {
    setPurchaseResult({
        isSuccess,
        productImageUrl: product.productImageUrl,
        title: product.title,
        errorCode: errorCode,
    });
}
function webPurchaseProduct(product, paymentMethod, tsv, purchaseTwoFactorData, transactionId, checkSecureStatus = false) {
    return __awaiter(this, void 0, void 0, function* () {
        function securePurchase() {
            return __awaiter(this, void 0, void 0, function* () {
                const isDisabled = [TSV_ACCOUNT_STATUSES.DISABLED, TSV_ACCOUNT_STATUSES.NOT_BOUND].includes(tsv.accountStatus);
                const isMandatoryCheck = tsv.mandatoryCheck;
                if (tsv.accountStatus === TSV_ACCOUNT_STATUSES.ENABLED || (isMandatoryCheck && isDisabled)) {
                    setTwoFactorValidation(true);
                    toogleVisibilityConfirmPurchasePopup(true);
                    return true;
                }
                return false;
            });
        }
        function _purchase() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                let twoStepValidation = null;
                if (tsv.accountStatus === TSV_ACCOUNT_STATUSES.ENABLED) {
                    twoStepValidation = {
                        method: purchaseTwoFactorData.method,
                        value: purchaseTwoFactorData.code,
                    };
                }
                setBlur(true);
                setLoading(true);
                try {
                    const response = yield webCommitPurchase(transactionId, (_a = paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.bindingsInfo) === null || _a === void 0 ? void 0 : _a[0].bindingId, collectBrowserInfo(), twoStepValidation, settings.backendUrl, settings.language);
                    if (response.nextAction && response.nextAction.code === COMMIT_NEXT_ACTION_CODES.THREE_DS_REQUIRED) {
                        return yield handleThreeDS(product, response.nextAction, transactionId);
                    }
                    setLoading(false);
                    showPurchaseResult(product, true);
                    toogleVisibilityConfirmPurchasePopup(false);
                    sendDwhEvent(product, DWH_EVENTS.PURCHASE_SUCCESS);
                }
                catch (err) {
                    warn(err);
                    if (err.message === PURCHASE_ERROR_CODES.TSV_INVALID_OTP_CODE) {
                        const errorText = getPurchaseErrorCodeText(PURCHASE_ERROR_CODES.TSV_INVALID_OTP_CODE);
                        setValidationErrorCode(errorText);
                        setLoading(false);
                        return false;
                    }
                    else {
                        setLoading(false);
                        showPurchaseResult(product, false);
                        toogleVisibilityConfirmPurchasePopup(false);
                        setBlur(false);
                        setValidationErrorCode(null);
                        sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
                    }
                }
            });
        }
        if (!checkSecureStatus) {
            _purchase();
        }
        else {
            securePurchase().then((isSecure) => !isSecure && _purchase());
        }
    });
}
function steamPurchaseProduct(product, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            setBlur(true);
            setLoading(true);
            const response = yield checkout$1(product.externalProductId, storefrontName || settings.storefrontName);
            setLoading(false);
            if (response.purchaseStatus === PURCHASE_STATUSES.SUCCESS) {
                showPurchaseResult(product, true);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_SUCCESS);
            }
            else if (response.purchaseStatus === PURCHASE_STATUSES.ERROR) {
                showPurchaseResult(product, false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
            }
            else {
                setBlur(false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_CANCELED);
                events.emit(EVENTS.CLOSE_FASTGOLD_OVERLAY);
            }
        }
        catch (e) {
            setLoading(false);
            showPurchaseResult(product, false);
            sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
        }
    });
}
function egsPurchaseProduct(product, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            setBlur(true);
            setLoading(true);
            const response = yield checkout$2(product.externalProductId, storefrontName || settings.storefrontName);
            setLoading(false);
            if (response.purchaseStatus === PURCHASE_STATUSES.SUCCESS) {
                showPurchaseResult(product, true);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_SUCCESS);
            }
            else if (response.purchaseStatus === PURCHASE_STATUSES.ERROR) {
                showPurchaseResult(product, false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
            }
            else {
                setBlur(false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_CANCELED);
                events.emit(EVENTS.CLOSE_FASTGOLD_OVERLAY);
            }
        }
        catch (e) {
            setLoading(false);
            showPurchaseResult(product, false);
            sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
        }
    });
}
function winStorePurchaseProduct(product, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            setBlur(true);
            const response = yield checkout(product.externalProductId, storefrontName || settings.storefrontName);
            setLoading(false);
            if (response.purchaseStatus === PURCHASE_STATUSES.SUCCESS) {
                showPurchaseResult(product, true);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_SUCCESS);
            }
            else if (response.purchaseStatus === PURCHASE_STATUSES.ERROR) {
                showPurchaseResult(product, false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
            }
            else {
                setBlur(false);
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_CANCELED);
                events.emit(EVENTS.CLOSE_FASTGOLD_OVERLAY);
            }
        }
        catch (e) {
            setLoading(false);
            showPurchaseResult(product, false);
            sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
        }
    });
}
function handleThreeDS(product, nextAction, transactionId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        setLoading(false);
        toogleVisibilityConfirmPurchasePopup(true);
        setThreeDSValidation(true);
        if (nextAction.redirectUrl) {
            setThreeDSRedirectUrl(nextAction.redirectUrl);
            openUrl(nextAction.redirectUrl);
        }
        const { status } = yield webThreeDSStatus(transactionId, settings.backendUrl, settings.language);
        if (status === THREE_DS_STATUSES.IN_PROGRESS) {
            return;
        }
        const purchaseStatus = (_a = {
            [THREE_DS_STATUSES.AUTHORISED]: PURCHASE_STATUSES.SUCCESS,
            [THREE_DS_STATUSES.CANCELLED]: PURCHASE_STATUSES.CANCELLED,
            [THREE_DS_STATUSES.UNEXPECTED]: PURCHASE_STATUSES.ERROR,
        }[status]) !== null && _a !== void 0 ? _a : PURCHASE_STATUSES.ERROR;
        toogleVisibilityConfirmPurchasePopup(false);
        setBlur(true);
        showPurchaseResult(product, purchaseStatus === PURCHASE_STATUSES.SUCCESS);
        switch (purchaseStatus) {
            case PURCHASE_STATUSES.SUCCESS:
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_SUCCESS);
                break;
            case PURCHASE_STATUSES.ERROR:
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_ERROR);
                break;
            case PURCHASE_STATUSES.CANCELLED:
                sendDwhEvent(product, DWH_EVENTS.PURCHASE_CANCELED);
                break;
        }
        return;
    });
}
function purchaseProduct(product, paymentMethod, tsv, purchaseTwoFactorData, transactionId, checkSecureStatus = false, storefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const platform = detectPlatform();
        switch (platform) {
            case PLATFORMS.WEB:
                yield webPurchaseProduct(product, paymentMethod, tsv, purchaseTwoFactorData, transactionId, checkSecureStatus);
                break;
            case PLATFORMS.EGS:
                yield egsPurchaseProduct(product, storefrontName);
                break;
            case PLATFORMS.STEAM:
                yield steamPurchaseProduct(product, storefrontName);
                break;
            case PLATFORMS.WIN_STORE:
                yield winStorePurchaseProduct(product, storefrontName);
                break;
            default:
                showPurchaseResult(product, false);
                break;
        }
    });
}

export { purchaseProduct, showPurchaseResult };
//# sourceMappingURL=purchase.js.map
